import { useNavigate } from 'react-router-dom';
import { useInView } from '../../hooks/useInView';
import { ArrowRight } from 'lucide-react';

export default function CTASection() {
  const navigate = useNavigate();
  const [ref, isInView] = useInView({ threshold: 0.3 });

  return (
    <section className="relative py-32 overflow-hidden" data-testid="cta-section">
      <div className="absolute inset-0 bg-gradient-to-b from-background via-primary/[0.05] to-background" />
      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{ backgroundImage: `radial-gradient(circle, hsl(var(--foreground)) 1px, transparent 1px)`, backgroundSize: '32px 32px' }}
      />

      <div className="relative mx-auto max-w-4xl px-6 text-center" ref={ref}>
        <div className={`transition-all duration-1000 ${isInView ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-foreground mb-6 leading-tight">
            Comece a controlar suas finanças hoje
          </h2>
          <p className="text-lg text-muted-foreground mb-10 max-w-xl mx-auto">
            Junte-se a milhares de brasileiros que já organizam suas finanças com IA e WhatsApp. Teste grátis por 7 dias.
          </p>

          <div className="flex flex-wrap items-center justify-center gap-4">
            <button
              onClick={() => document.getElementById('planos')?.scrollIntoView({ behavior: 'smooth' })}
              data-testid="cta-primary"
              className="group inline-flex items-center gap-2 bg-primary text-primary-foreground hover:bg-primary/90 rounded-xl font-semibold px-8 py-4 transition-all active:scale-95 shadow-[0_0_40px_-10px_hsl(var(--primary)/0.5)] hover:shadow-[0_0_50px_-10px_hsl(var(--primary)/0.7)]"
            >
              Escolher meu Plano
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </button>
            <button
              onClick={() => navigate('/login')}
              data-testid="cta-secondary"
              className="inline-flex items-center gap-2 text-foreground hover:text-primary font-medium px-8 py-4 rounded-xl border border-border/60 hover:border-primary/30 transition-all"
            >
              Já tenho conta → Login
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
